/* eslint-disable react-perf/jsx-no-jsx-as-prop */
import React from 'react';
import EmptyState from 'Components/EmptyState/EmptyState';
import { fileNames } from 'Constants/imageUrls';
import { staticHeading } from 'Constants/sellCarO2O';
import Header from '../Header/Header';
import css from './ErrorBoundary.scss';
import PropTypes from 'prop-types';
import { FormattedMessage as Translation } from 'react-intl';

const ErrorBoundary = ({ id, handleBack, handleCrossClick, handleErrorClick }) => {
    const oops = <Translation id="oops" />;
    const reviews_error_desc = <Translation id="reviews_error_desc" />;
    const locationErrorTooltipTry = <Translation id="locationErrorTooltipTry" />;
    const retry = <Translation id="retry" />;

    return (
        <div>
            {
                staticHeading[id]
                    && <Header
                        val={ staticHeading[id] }
                        isBack={ id !== 'make' }
                        handleBack={ handleBack }
                        handleCrossClick={ handleCrossClick }
                    />
            }
            <EmptyState
                title={ <React.Fragment>
                    <div>{ oops }</div>
                    <div>{ reviews_error_desc }</div>
                    <div>{ locationErrorTooltipTry }</div>
                </React.Fragment> }
                asset={ fileNames.ERROR_IMG }
                buttonText={ <span>{ retry }</span> }
                onClick={ handleErrorClick }
                className={ css.errorState }
            />
        </div>
    );
};

ErrorBoundary.propTypes = {
    handleBack: PropTypes.func,
    handleCrossClick: PropTypes.func,
    handleErrorClick: PropTypes.func,
    id: PropTypes.string
};

ErrorBoundary.defaultProps = {
    handleBack: () => {},
    handleCrossClick: () => {},
    id: ''
};

export default ErrorBoundary;
